<template>
<transition name="fade" mode="out-in" appear>
    <component :is="component" :params="params" :formData="formData" :Lead="Lead" :AA_Number="AA_Number" :middle_dataware="middle_dataware" :screenWidth="screenWidth"></component>
</transition>
</template>
<script>
  export default {
    props: ['component', 'formData', 'params', 'Lead', 'AA_Number', 'middle_dataware', 'screenWidth'],
    data(){
        return {
        }
    },
    methods:{
    }
  }

</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/step-components.vue